import React, { useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const warningMessage = `If you delete it, attachment syncing according to this setting will be stopped.`;
function DeleteModuleSetting(props) {
  const { service, handleRevokeService } = props;
  const [revokeOpen, setRevokeOpen] = useState(false);

  const handleClickRevokeOpen = () => {
    setRevokeOpen(true);
  };

  const handleRevokeClose = () => {
    setRevokeOpen(false);
  };

  return (
    <>
      <Button
        variant="text"
        color="error"
        size="small"
        onClick={handleClickRevokeOpen}
        sx={{
          backgroundColor: "#fff5f5",
          border: "1px solid #ffecec",
          fontWeight: 500,
          textTransform: "none",
          width: "100%",
        }}
      >
        Delete
      </Button>
      <Dialog
        open={revokeOpen}
        onClose={handleRevokeClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Do you want to delete `}
          <strong>{service?.service?.displayLabel}</strong>
          {` setting?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {warningMessage}
            <br />
            {`Module: `}
            <strong>{service?.module?.displayLabel}</strong>
            <br />
            {`Record Field: `}
            <strong>{service?.modulefield?.fieldDisplayLabel}</strong>
            <br />

            {`Root Folder: `}
            <strong>
              {service?.workspace?.name} / {service?.teamFolder?.name} /{" "}
              {service?.rootFolder?.name}
            </strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRevokeClose}
            autoFocus
            variant="contained"
            color="success"
          >
            Dont Delete
          </Button>
          <Button
            onClick={handleRevokeService}
            variant="outlined"
            color="error"
          >
            I want to delete {service?.service?.displayLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeleteModuleSetting;
